import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Award, FileCheck, TrendingUp, Users, Calendar, DollarSign, CheckCircle, Clock, BarChart, FileText, Shield } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/Table';
export function CommitteeDashboard() {
  const navigate = useNavigate();
  const stats = [{
    label: 'Kebijakan Menunggu',
    value: '5',
    trend: 'Perlu persetujuan',
    icon: FileCheck,
    color: 'text-warning',
    bgColor: 'bg-warning-light'
  }, {
    label: 'Chapter Aktif',
    value: '12',
    trend: '+2 kuartal ini',
    icon: Users,
    color: 'text-atios-primary',
    bgColor: 'bg-atios-light'
  }, {
    label: 'Total Acara',
    value: '48',
    trend: 'Tahun ini',
    icon: Calendar,
    color: 'text-success',
    bgColor: 'bg-success-light'
  }, {
    label: 'Utilisasi Anggaran',
    value: '68%',
    trend: 'Sesuai target',
    icon: DollarSign,
    color: 'text-atios-primary',
    bgColor: 'bg-atios-light'
  }];
  const pendingApprovals = [{
    id: 1,
    title: 'Pembentukan Chapter Baru - Surabaya',
    type: 'Chapter',
    submittedBy: 'Made Suryawan',
    date: '2 hari lalu'
  }, {
    id: 2,
    title: 'Permintaan Peningkatan Anggaran Q1 2025',
    type: 'Keuangan',
    submittedBy: 'Dewi Lestari',
    date: '3 hari lalu'
  }, {
    id: 3,
    title: 'Kemitraan dengan Tech Corp',
    type: 'Kemitraan',
    submittedBy: 'Ahmad Wijaya',
    date: '5 hari lalu'
  }];
  const chapterReports = [{
    chapter: 'Jakarta Tech Community',
    members: 245,
    events: 12,
    rating: 4.8
  }, {
    chapter: 'Bandung Developer Circle',
    members: 189,
    events: 8,
    rating: 4.6
  }, {
    chapter: 'Surabaya Tech Hub',
    members: 156,
    events: 10,
    rating: 4.7
  }];
  const handleApprove = (id: number) => {
    if (confirm('Apakah Anda yakin ingin menyetujui permohonan ini?')) {
      alert(`Permohonan #${id} telah disetujui`);
    }
  };
  const handleReview = (id: number) => {
    navigate(`/committee/approvals/${id}`);
  };
  return <div className="min-h-screen bg-white" data-id="element-1864">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8" data-id="element-1865">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-1866">
          <div data-id="element-1867">
            <div className="flex items-center gap-2 sm:gap-3 mb-2" data-id="element-1868">
              <h1 className="text-xl sm:text-2xl lg:text-3xl font-semibold text-neutral-900" data-id="element-1869">
                Dasbor Komite Pusat
              </h1>
              <Badge className="bg-warning text-white font-semibold text-xs" data-id="element-1870">
                KOMITE
              </Badge>
            </div>
            <p className="text-sm sm:text-base text-neutral-600" data-id="element-1871">
              Pengawasan organisasi dan manajemen kebijakan
            </p>
          </div>
          <div className="flex gap-2 sm:gap-3" data-id="element-1872">
            <Button variant="secondary" size="sm" onClick={() => navigate('/committee/policies')} className="flex-1 sm:flex-none" data-id="element-1873">
              <FileCheck className="w-4 h-4 sm:mr-2" data-id="element-1874" />
              <span className="hidden sm:inline" data-id="element-1875">Review Kebijakan</span>
              <span className="sm:hidden" data-id="element-1876">Kebijakan</span>
            </Button>
            <Button size="sm" onClick={() => navigate('/committee/reports')} className="flex-1 sm:flex-none" data-id="element-1877">
              <FileText className="w-4 h-4 sm:mr-2" data-id="element-1878" />
              <span className="hidden sm:inline" data-id="element-1879">Laporan</span>
              <span className="sm:hidden" data-id="element-1880">Laporan</span>
            </Button>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6" data-id="element-1881">
          {stats.map((stat, i) => <Card key={i} data-id="element-1882">
              <CardContent className="p-4 sm:p-6" data-id="element-1883">
                <div className="flex justify-between items-start mb-3 sm:mb-4" data-id="element-1884">
                  <div className={`p-2 sm:p-3 rounded-lg ${stat.bgColor}`} data-id="element-1885">
                    <stat.icon className={`w-5 h-5 sm:w-6 sm:h-6 ${stat.color}`} data-id="element-1886" />
                  </div>
                  <TrendingUp className="w-4 h-4 text-success" data-id="element-1887" />
                </div>
                <div className="space-y-1" data-id="element-1888">
                  <h3 className="text-xl sm:text-2xl font-semibold text-neutral-900" data-id="element-1889">
                    {stat.value}
                  </h3>
                  <p className="text-xs sm:text-sm text-neutral-600" data-id="element-1890">
                    {stat.label}
                  </p>
                </div>
                <p className="text-xs mt-2 sm:mt-3 text-neutral-500" data-id="element-1891">
                  {stat.trend}
                </p>
              </CardContent>
            </Card>)}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8" data-id="element-1892">
          {/* Pending Approvals */}
          <Card data-id="element-1893">
            <CardHeader className="flex flex-row items-center justify-between" data-id="element-1894">
              <CardTitle className="text-base sm:text-lg" data-id="element-1895">
                Menunggu Persetujuan
              </CardTitle>
              <Button variant="link" className="text-atios-primary text-sm" onClick={() => navigate('/committee/approvals')} data-id="element-1896">
                Lihat Semua
              </Button>
            </CardHeader>
            <CardContent data-id="element-1897">
              <div className="space-y-3 sm:space-y-4" data-id="element-1898">
                {pendingApprovals.map(item => <div key={item.id} className="p-3 sm:p-4 rounded-lg border border-neutral-200 hover:border-atios-primary transition-all" data-id="element-1899">
                    <div className="flex items-start justify-between gap-2 mb-2" data-id="element-1900">
                      <h4 className="font-medium text-sm sm:text-base text-neutral-900 flex-1" data-id="element-1901">
                        {item.title}
                      </h4>
                      <Badge variant="warning" className="text-xs flex-shrink-0" data-id="element-1902">
                        {item.type}
                      </Badge>
                    </div>
                    <p className="text-xs sm:text-sm text-neutral-600 mb-3" data-id="element-1903">
                      Diajukan oleh {item.submittedBy} • {item.date}
                    </p>
                    <div className="flex gap-2" data-id="element-1904">
                      <Button size="sm" variant="secondary" onClick={() => handleReview(item.id)} className="flex-1 sm:flex-none" data-id="element-1905">
                        <Clock className="w-4 h-4 sm:mr-2" data-id="element-1906" />
                        <span className="text-xs sm:text-sm" data-id="element-1907">Review</span>
                      </Button>
                      <Button size="sm" onClick={() => handleApprove(item.id)} className="flex-1 sm:flex-none" data-id="element-1908">
                        <CheckCircle className="w-4 h-4 sm:mr-2" data-id="element-1909" />
                        <span className="text-xs sm:text-sm" data-id="element-1910">Setujui</span>
                      </Button>
                    </div>
                  </div>)}
              </div>
            </CardContent>
          </Card>

          {/* Chapter Performance */}
          <Card data-id="element-1911">
            <CardHeader className="flex flex-row items-center justify-between" data-id="element-1912">
              <CardTitle className="text-base sm:text-lg" data-id="element-1913">
                Kinerja Chapter
              </CardTitle>
              <Button variant="link" className="text-atios-primary text-sm" onClick={() => navigate('/chapter')} data-id="element-1914">
                Lihat Semua
              </Button>
            </CardHeader>
            <CardContent data-id="element-1915">
              <div className="overflow-x-auto -mx-4 sm:mx-0" data-id="element-1916">
                <div className="inline-block min-w-full align-middle" data-id="element-1917">
                  <Table data-id="element-1918">
                    <TableHeader data-id="element-1919">
                      <TableRow data-id="element-1920">
                        <TableHead className="text-xs sm:text-sm" data-id="element-1921">
                          Chapter
                        </TableHead>
                        <TableHead className="text-xs sm:text-sm" data-id="element-1922">
                          Anggota
                        </TableHead>
                        <TableHead className="text-xs sm:text-sm" data-id="element-1923">
                          Acara
                        </TableHead>
                        <TableHead className="text-xs sm:text-sm" data-id="element-1924">
                          Rating
                        </TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody data-id="element-1925">
                      {chapterReports.map((chapter, i) => <TableRow key={i} data-id="element-1926">
                          <TableCell className="font-medium text-xs sm:text-sm text-neutral-900" data-id="element-1927">
                            {chapter.chapter}
                          </TableCell>
                          <TableCell className="text-xs sm:text-sm" data-id="element-1928">
                            {chapter.members}
                          </TableCell>
                          <TableCell className="text-xs sm:text-sm" data-id="element-1929">
                            {chapter.events}
                          </TableCell>
                          <TableCell data-id="element-1930">
                            <div className="flex items-center gap-1" data-id="element-1931">
                              <Award className="w-3 h-3 sm:w-4 sm:h-4 text-warning" data-id="element-1932" />
                              <span className="font-medium text-xs sm:text-sm" data-id="element-1933">
                                {chapter.rating}
                              </span>
                            </div>
                          </TableCell>
                        </TableRow>)}
                    </TableBody>
                  </Table>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Quick Actions */}
        <div data-id="element-1934">
          <h2 className="text-base sm:text-lg font-semibold text-neutral-900 mb-4" data-id="element-1935">
            Aksi Cepat
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4" data-id="element-1936">
            {[{
            label: 'Persetujuan Event',
            icon: Calendar,
            onClick: () => navigate('/committee/events/approvals')
          }, {
            label: 'Kelola Kebijakan',
            icon: FileCheck,
            onClick: () => navigate('/committee/policies')
          }, {
            label: 'Lihat Laporan',
            icon: BarChart,
            onClick: () => navigate('/committee/reports')
          }, {
            label: 'Audit Kepatuhan',
            icon: Shield,
            onClick: () => navigate('/committee/compliance')
          }].map((action, i) => <Button key={i} variant="secondary" className="h-auto py-3 sm:py-4 flex flex-col gap-2 hover:border-atios-primary transition-all" onClick={action.onClick} data-id="element-1937">
                <action.icon className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-1938" />
                <span className="text-xs sm:text-sm text-center" data-id="element-1939">
                  {action.label}
                </span>
              </Button>)}
          </div>
        </div>
      </div>
    </div>;
}